// Works in CRA and Vite
const BASE =
  (typeof import.meta !== "undefined" && import.meta.env && import.meta.env.BASE_URL) ||
  process.env.PUBLIC_URL ||
  "";

// Optional short names → public paths (handy if you use "asset:guitar1" in JSON)
const ASSETS = {
  guitar1: "/assets/images/guitar1.png",
  violin1: "/assets/images/violin1.png",
  flute1: "/assets/images/flute1.png",
  trumpet1: "/assets/images/trumpet1.png",
  drum1: "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/images%2Fdrum1.png?alt=media&token=d81af444-89c5-4005-8158-31ba47a42f10",
  chestOpen: "/assets/images/chest-open.png",
};

export function resolveImageSrc(value) {
  if (!value) return null;
  if (/^https?:\/\//i.test(value)) return value;      // Firebase URLs
  if (value.startsWith("asset:")) {
    const key = value.slice(6);
    return ASSETS[key] ? BASE + ASSETS[key] : null;
  }
  if (value.startsWith("/assets/")) return BASE + value; // public/ assets
  return value; // last-resort
}
